/**
 * Canonical measurement unit codes (stored in the DB / used by the app + formulas)
 * mapped to their Hebrew display labels. Store the code, display the label.
 */
export interface UnitOption {
  value: string;
  label: string;
}

export const UNIT_OPTIONS: UnitOption[] = [
  { value: "cm", label: 'ס״מ' },
  { value: "kg", label: 'ק״ג' },
  { value: "%", label: "%" },
];

const UNIT_LABELS: Record<string, string> = UNIT_OPTIONS.reduce(
    (acc: Record<string, string>, u) => { acc[u.value] = u.label; return acc; },
    {},
);

/** Hebrew label for a stored unit code; falls back to the code itself. */
export const unitLabel = (code?: string | null): string => (code ? (UNIT_LABELS[code] || code) : "—");
